import React from "react";
import "./Combo_Offer_Swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { IDS } from "../../../utils/IDS";

const Combo_Offer_Swiper = ({ data }) => {

  return (
    <section className="Combo_Offer_Swiper">
      <div className="container">
        <div className="yellow_bg_div">
          <div className="slider_sec">
            <Swiper

              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 10,
                },
                575: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
              className="mySwiper"
            >
              {data.map((item, index) => (
                <SwiperSlide>
                  <div className="combo_offer_div">
                    <div className="img_holder">
                      <img src={IDS.IMG_URL + item?.image} className="offer_img" />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Combo_Offer_Swiper;
